<script setup lang="ts">
import MarkdownView from "@/core/components/markdown/Markdown.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import ExpandableTextOverflow from "@/core/components/expandable-text-overflow/ExpandableTextOverflow.vue";
import BaseCardHeader from "@/core/components/base/BaseCardHeader.vue";
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{summary: string}>();
</script>

<template>
  <BaseCard>
    <BaseCardHeader>
      <h2>
        Résumé
        <Icon name="mdi-creation" color="primary" />
      </h2>
    </BaseCardHeader>
    <BaseCardBody>
      <ExpandableTextOverflow :background-color="{red: 255, green: 255, blue: 255}">
        <MarkdownView :content="summary" inherit-styles class="text-sm" />
      </ExpandableTextOverflow>
    </BaseCardBody>
  </BaseCard>
</template>

<style scoped>

</style>
